import AppHeader from "@saleor/components/AppHeader";
import { Container } from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import {
  RemittanceMallsConfig,
  RemittanceMallsConfig_malls_edges_node,
  RemittanceMallsConfigVariables
} from "@saleor/riderRemittanceConfig/types/RemittanceMallsConfig";
import { PageListProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import ReminderList from "../ReminderList";

export interface FormData {
  includeTax: boolean;
  showGross: boolean;
  chargeTaxesOnShipping: boolean;
}
export interface RiderRemittanceConfigPageProps extends PageListProps {
  onBack?: () => void;
  refetch: (variables?: RemittanceMallsConfigVariables) => any;
  data: RemittanceMallsConfig;
  mallList: RemittanceMallsConfig_malls_edges_node[];
}

const RiderRemittanceConfigPage: React.FC<RiderRemittanceConfigPageProps> = ({
  onBack,
  refetch,
  data,
  mallList,
  ...listProps
}) => {
  const intl = useIntl();

  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {intl.formatMessage(sectionNames.configuration)}
        </AppHeader>
        <PageHeader
          title={intl.formatMessage({
            defaultMessage: "Rider Remittance Reminders",
            description: "header"
          })}
        />
        <div>
          <ReminderList
            mallList={mallList}
            refetch={refetch}
            disabled={false}
            {...listProps}
          />
        </div>
      </Container>
    </>
  );
};
RiderRemittanceConfigPage.displayName = "RiderRemittanceConfigPage";
export default RiderRemittanceConfigPage;
